import { logOut } from "../actions/session";
import { ApolloLink } from "@apollo/client";
import { onError } from "@apollo/client/link/error";

// Store original fetch function
const originalFetch = global.fetch;

// Create our interceptor function for regular fetch
function interceptFetch(...args) {
    return originalFetch.apply(null, args)
        .then(response => {
            // Check for unauthorized or forbidden status
            if ((response.status === 401 || response.status === 403) &&
                !window.location.pathname.includes('/login') &&
                !window.location.pathname.includes('/user/logout')
            ) {
                console.warn(`Authentication error (${response.status}). Logging out...`);
                handleLogout();
            }
            return response;
        });
}

// Replace the global fetch with our interceptor
global.fetch = interceptFetch;

// Create Apollo error link for GraphQL requests
export const createAuthErrorLink = (dispatch) => {
    return onError(({ graphQLErrors, networkError }) => {
        // Handle network errors (including 401/403)
        if (networkError && (networkError.statusCode === 401 || networkError.statusCode === 403)) {
            console.warn(`Apollo network error (${networkError.statusCode}). Logging out...`);
            handleLogout(dispatch);
        }

        // Handle GraphQL errors with auth issues
        if (graphQLErrors) {
            const authError = graphQLErrors.find(error =>
                error.extensions?.code === 'UNAUTHENTICATED' ||
                error.message.includes('not authenticated') ||
                error.message.includes('not authorized')
            );

            if (authError && !window.location.pathname.includes('/login')) {
                console.warn('Apollo GraphQL authentication error. Logging out...');
                handleLogout(dispatch);
            }
        }
    });
};

// Centralized logout handling
function handleLogout(dispatch) {
    if (window.location.pathname.includes('/login') || window.location.pathname.includes('/user/logout')) {
        return; // Prevent logout loop if we're already on login page
    }

    if (dispatch) {
        // If we have dispatch function, use Redux action
        dispatch(logOut());
    }

    // Redirect to login page
    //window.location.href = '/login';
}

export const initFetchInterceptor = (apolloClient, dispatch) => {
    console.log('Fetch interceptor initialized');

    // If Apollo client is provided, add the auth error link
    if (apolloClient) {
        const authErrorLink = createAuthErrorLink(dispatch);

        // Insert our error link into the Apollo link chain
        const currentLinks = apolloClient.link;
        apolloClient.setLink(ApolloLink.from([authErrorLink, currentLinks]));
    }
};